<template>
    <div>
        <span :class="firstElClasses">
            {{
                pagination.page * pagination.pageSize + 1 - pagination.pageSize
            }}
            -
        </span>
        {{
            Math.min(
                pagination.page * pagination.pageSize,
                pagination.totalProducts
            )
        }}

        из {{ pagination.totalProducts }}
    </div>
</template>

<script>
export default {
    name: 'PaginationInfo',
    props: {
        pagination: {
            type: Object,
            required: true
        },
        isHiddenFirstElOnMobile: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        firstElClasses() {
            if (this.isHiddenFirstElOnMobile) {
                return ['d-none', 'd-md-inline-block']
            }

            return ''
        }
    }
}
</script>
